<template>
  <form class="space-y-6" @submit.prevent="onSubmit">
    <div>
      <InputComponent
        :label="AuthService.translate('login.email')?.value"
        type="email"
        v-model="email"
        required
        class=""
        placeholder="Adresse mail"
      />
    </div>

    <div>
      <InputComponent
        label="Mot de passe"
        type="password"
        required
        v-model="password"
        class=""
      />
    </div>
    <button
      :disabled="loading"
      :loading="loading"
      type="submit"
      class="buttonComponent w-full"
    >
      Me connecter
    </button>
  </form>
</template>

<script setup>
import { ref } from 'vue'
import InputComponent from '@/presentation/components/input/InputComponent.vue'
import AuthService from '@/features/auth/authService'

const email = ref('')
const password = ref('')
const loading = ref(false)

function onSubmit() {
  const data = {
    email: email.value,
    password: password.value,
  }
  AuthService.login(data)
}
</script>
